import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { systemVersionService } from '@/services/system_version_service'
import { toast } from 'sonner'
import { SystemVersion } from '@magnetar/admin-api-interfaces'
import { useAuth } from '@/hooks/useAuth'

interface DeleteAlertProps {
  systemVersion: SystemVersion
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess: () => void
}

export function DeleteAlert({ systemVersion, open, onOpenChange, onSuccess }: DeleteAlertProps) {
  const { token } = useAuth()

  const handleDelete = async () => {
    try {
      const result = await systemVersionService.deleteSystemVersion(systemVersion.update_id, token)

      if (result.success) {
        toast.success(`系統版本 ${systemVersion.version} 已刪除`)
        onSuccess()
        onOpenChange(false)
      } else {
        toast.error('刪除系統版本失敗')
      }
    } catch {
      toast.error('刪除系統版本失敗')
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>確定要刪除此系統版本？</AlertDialogTitle>
          <AlertDialogDescription>
            此操作無法復原。這將永久刪除系統版本 {systemVersion.version} 及其所有相關設定。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>取消</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            刪除
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
